export default __webpack_public_path__ + "static/media/PN.031ab6a0.svg";